module.exports = __webpack_public_path__ + "img/ofszetnyomtatas.f0700e10.jpg";